import React, { FC, useCallback, useState } from 'react';

import { Label } from './styled';

export interface IBaseSwitcherProps {
    id?: string,
    name?: string,
    value?: string,
    checked?: boolean,
    disabled?: boolean,
    required?: boolean,
    onChange?: (event: React.ChangeEvent<HTMLInputElement>, state?: boolean) => void,
    className?: string,
    [key: string]: unknown,
}

const BaseSwitcher: FC<IBaseSwitcherProps> = ({
    id,
    name = '',
    value = '',
    checked,
    disabled = false,
    required,
    children,
    onChange,
    className,
    ...props
}) => {
    const [isChecked, setIsChecked] = useState(checked);

    const onChangeHandler = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
        if (!disabled) {
            if (required) {
                if (!isChecked) {
                    setIsChecked(true);
                    onChange && onChange(event, true);
                }
            } else {
                setIsChecked(!isChecked);
                onChange && onChange(event, !isChecked);
            }
        }
    }, [disabled, isChecked, onChange, required]);

    return (
        <Label
            checked={checked}
            disabled={disabled}
            className={className}
            {...props}
        >
            <input
                type={'checkbox'}
                id={id}
                name={name}
                value={value}
                checked={required ? isChecked : checked}
                disabled={disabled}
                required={required}
                onChange={onChangeHandler}
                data-test={'Switcher'}
            />
            {children}
        </Label>
    );
};

export default BaseSwitcher;
